import { hasOwn } from './hasOwn';

import type { PostsWithSpotTypeByOwnerQuery } from '@/app/api/generated';
import type { Spot, Map } from '@/types';
import { convertMeters, calcDistance } from '@/utils';

export const convertedSpots = (
  spotList: Omit<Spot, 'geoPoint'>[] | PostsWithSpotTypeByOwnerQuery['assets'],
  currentLocation: Map['currentLocation']
) => {
  const tmp = spotList.map((value) => {
    if (typeof value.location === 'undefined') return { ...value };
    if (
      !hasOwn(value.location, 'geometry') ||
      !hasOwn(value.location.geometry, 'coordinates')
    )
      return { ...value };
    const coordinates = value.location.geometry.coordinates;
    if (
      currentLocation.latitude === undefined ||
      currentLocation.longitude === undefined
    )
      return { ...value };

    return {
      ...value,
      geoPoint: {
        ...value.location,
        distance: calcDistance(
          {
            latitude: currentLocation.latitude,
            longitude: currentLocation.longitude,
          },
          {
            latitude: coordinates[1],
            longitude: coordinates[0],
          }
        ),
        conversionDistance: convertMeters(
          calcDistance(
            {
              latitude: currentLocation.latitude,
              longitude: currentLocation.longitude,
            },
            {
              latitude: coordinates[1],
              longitude: coordinates[0],
            }
          )
        ),
        distanceUnit:
          calcDistance(
            {
              latitude: currentLocation.latitude,
              longitude: currentLocation.longitude,
            },
            {
              latitude: coordinates[1],
              longitude: coordinates[0],
            }
          ) < 1000
            ? 'm'
            : 'km',
      },
    };
  });

  return tmp;
};
